import { createContext, useContext } from 'react';
import { Translator } from '~domain/i18n';

export const TranslatorContext = createContext<Translator>(null);

export const useTranslator = () => useContext(TranslatorContext);
